import React from 'react';
import queryString from 'query-string';
import { Form, Progress } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';

import { WithLocalize } from '../../containers/I18nProvider';
import { WithCaptcha } from '../../containers/captcha';

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.parameters = queryString.parse(props.location.search);
    this.parameters.idp = 'sumi';
    this.ref = React.createRef();
    this.state = {
      onLogin: false,
      showForm: false,
      error: {
        open: false,
        message: ''
      },
      username: '',
      password: ''
    };
  }

  componentDidMount() {

    this.setState({ showForm: true });
  }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message
      }
    });
  }

  async onSubmit(ev) {
    ev.preventDefault();

    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: ''
      }
    });



    this.props.api.userPassLogin(
      {
        username: this.usernameInput.value,
        password: this.passwordInput.value
      }, this.parameters

    )
      .then((response) => {
        this.setState({ onLogin: false });
        window.location = this.parameters.redirect_uri + '?' + queryString.stringify(response);
      })
      .catch(error => {
        const translate = this.props.translate(error.errorCode);

        let message = 'Usuário e/ou senha inválidos. Por favor, tente novamente.        ';

        if (translate) {
          message = translate;
        } else if (error.details) {
          message = error.details;
        }

        this.setState({ onLogin: false, error: { open: true, message: message } });
      });
  }

  render() {
    const { translate } = this.props;

    return (
      <CSSTransition
        in={this.state.showForm}
        timeout={300}
        classNames="formshow"
        nodeRef={this.ref}
        unmountOnExit
      >
        <>
          <div className="sumi-container" ref={this.ref}>
            <Form onSubmit={event => this.onSubmit(event)} className='sumi-form'>
              <input
                className='input-sumi'
                disabled={this.state.onLogin}
                ref={(ref) => {
                  this.usernameInput = ref;
                }
                }
                placeholder={translate("PlaceholderUserName")}
                required={true}
                tabIndex={1}
                type="text"
                autoCorrect="off"
                autoCapitalize="none"
                name="username"
              />
              <input
                className='input-sumi input-sumi-mt'
                required={true}
                disabled={this.state.onLogin}
                ref={(ref) => {
                  this.passwordInput = ref;
                }
                }
                placeholder={translate("PlaceholderPassword")}
                tabIndex={1}
                type="password"
                autoCorrect="off"
                autoCapitalize="none"
                name="password"
              />
              <div className="sumi-buttons">
                {!this.state.onLogin ?
                  <button
                    className='sumi-button'
                    block={!this.parameters.failureRedirect}
                    tabIndex={1}
                    type="submit"
                    name="submit"
                    disabled={!this.props.turnstileSuccess}
                  >
                    {translate('ButtonEnter')}
                  </button> :
                  <Progress animated color="primary" value={100} className='uplay-progress' />}
              </div>
              <this.props.TurnstileComponent setTurnstileSuccess={this.props.setTurnstileSuccess} />
            </Form>
          </div>
          <div className='sumi-error-container'>
            <span className='sumi-error-msg'>{this.state.error.message} </span>
          </div>
        </>
      </CSSTransition>
    );
  }
}

export default WithCaptcha(WithLocalize(LoginForm), { useInsideForm: true, style: { marginTop: '2rem' } });
